import { ILocation } from '../../types/location';
import { prepareLocation } from './prepareLocation';
import { ISearchCatalogItemSchema } from '../../repositories/geo-temp-layer/entities/catalog_item/SearchCatalogItemSchema';

export const prepareLocations = (locations?: ISearchCatalogItemSchema[] | null): ILocation[] => {
  if (!locations) {
    return [];
  }

  return locations.map(prepareLocation);
};
